import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn, FaWhatsapp, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  const footerLinks = [
    {
      title: 'Ürünlerimiz',
      links: [
        { name: 'Deck', path: '/products?category=deck' },
        { name: 'Çit Sistemleri', path: '/products?category=fence' },
        { name: 'Bahçe Kapı Sistemleri', path: '/products?category=garden_gate' },
        { name: 'Cephe Sistemleri-Vinylbond', path: '/products?category=facade' },
        { name: 'Pergola', path: '/products?category=pergola' },
        { name: 'Dekoratif Panel', path: '/products?category=decorative_panel' }
      ]
    },
    {
      title: 'Kurumsal',
      links: [
        { name: 'Hakkımızda', path: '/about' },
        { name: 'Gizlilik Politikası', path: '/privacy' },
        { name: 'Kullanım Koşulları', path: '/terms' },
        { name: 'Blog', path: '/blogs' }
      ]
    },
    {
      title: 'Destek',
      links: [
        { name: 'Montaj Kılavuzu', path: '/installation-guide' },
        { name: 'Sıkça Sorulan Sorular', path: '/faq' },
        { name: 'İade Politikası', path: '/return-policy' },
        { name: 'Ödeme Seçenekleri', path: '/payment-options' }
      ]
    }
  ];

  const socialLinks = [
    { Icon: FaFacebookF, url: 'https://www.facebook.com/DETAYDECKK/', label: 'Facebook' },
    { Icon: FaInstagram, url: 'https://www.instagram.com/detaydeck/', label: 'Instagram' },
    { Icon: FaTwitter, url: 'https://x.com/detaydeck', label: 'Twitter' },
    { Icon: FaLinkedinIn, url: 'https://linkedin.com/in/detay-deck-534753210', label: 'LinkedIn' },
    { Icon: FaWhatsapp, url: 'https://wa.me/905387416525', label: 'WhatsApp' }
  ];

  const contactInfo = [
    { Icon: FaPhone, text: '+90 538 741 65 25', href: 'tel:+905387416525' },
    { Icon: FaPhone, text: '+90 532 168 29 48', href: 'tel:+905321682948' },
    { Icon: FaEnvelope, text: 'detaydeck@gmail.com', href: 'mailto:detaydeck@gmail.com' },
    { Icon: FaMapMarkerAlt, text: 'Ahmediye, Çatalca Yolu Cd. No:201, 34537 Büyükçekmece/İstanbul', href: 'https://maps.app.goo.gl/48rYKxgSwjHRq33j9' }
  ];

  return (
    <footer className="bg-[rgb(26,26,26)] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top Section */}
        <div className="pt-16 pb-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            {/* Company Info */}
            <div className="space-y-6">
              <Link to="/" className="block">
                <img
                  src="/images/logos/pc-logo.png"
                  alt="DetayDeck"
                  className="h-10 brightness-0 invert"
                />
              </Link>
              <div className="space-y-4">
                {contactInfo.map(({ Icon, text, href }) => (
                  <a
                    key={text}
                    href={href}
                    className="flex items-center space-x-3 text-gray-300 hover:text-[#dbc582] transition-colors duration-200"
                  >
                    <Icon className="h-5 w-5" />
                    <span className="text-sm">{text}</span>
                  </a>
                ))}
              </div>
              <div className="flex space-x-4">
                {socialLinks.map(({ Icon, url, label }) => (
                  <a
                    key={label}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-[#dbc582] transition-colors duration-200"
                  >
                    <Icon className="h-5 w-5" />
                    <span className="sr-only">{label}</span>
                  </a>
                ))}
              </div>
            </div>

            {/* Footer Links */}
            {footerLinks.map((section) => (
              <div key={section.title} className="space-y-6">
                <h3 className="text-lg font-semibold text-[#dbc582]">{section.title}</h3>
                <ul className="space-y-4">
                  {section.links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-sm text-gray-300 hover:text-[#dbc582] transition-colors duration-200"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 py-16">
          <div className="flex flex-col md:flex-row justify-between items-center gap-10">
            <div className="flex-1 text-center md:text-left">
              <p className="text-sm text-gray-500">
                &copy; {new Date().getFullYear()} DetayDeck. Tüm hakları saklıdır.
                <span className="ml-2 text-gray-600">v2</span>
              </p>
            </div>

            <div className="flex-1 flex flex-col md:flex-row items-center justify-center gap-6">
              <img
                src="/images/ado/ado-footer.png"
                alt="ADOGROUP"
                className="h-12 brightness-0 invert"
              />
              <div className="text-center md:text-left">
                <p className="text-sm text-gray-400">
                  <span className="text-white font-bold text-lg tracking-widest block md:inline mb-1 md:mb-0 md:mr-2">DETAY DECK</span>
                  <span className="text-[#dbc582] font-semibold">ADOGROUP</span> Marmara Bölgesi Bayisidir
                </p>
              </div>
            </div>

            <div className="flex-1 flex justify-center md:justify-end space-x-6">
              <Link to="/privacy" className="text-sm text-gray-500 hover:text-[#dbc582] transition-colors duration-200">
                Gizlilik Politikası
              </Link>
              <Link to="/terms" className="text-sm text-gray-500 hover:text-[#dbc582] transition-colors duration-200">
                Kullanım Koşulları
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
